import {
    useEffect,
    useState
} from "react";

import {
    Link,
    useNavigate
} from "react-router-dom";

import API from "../../services/api";
import { hasPermission } from "../../utils/permission";

function SalesReturns() {

    const navigate =
        useNavigate();

    const [salesReturns,
        setSalesReturns] =
        useState([]);

    const [page,
        setPage] =
        useState(1);

    const [pages,
        setPages] =
        useState(1);

    const [search,
        setSearch] =
        useState("");

    useEffect(() => {

        loadSalesReturns();

    }, [
        page,
        search
    ]);

    const loadSalesReturns =
        async () => {

            try {

                const token =
                    localStorage.getItem(
                        "adminToken"
                    );

                const res =
                    await API.get(
                        `/sales-returns?page=${page}&search=${search}`,
                        {
                            headers: {
                                Authorization:
                                    `Bearer ${token}`
                            }
                        }
                    );

                setSalesReturns(
                    res.data.salesReturns
                );

                setPages(
                    res.data.pages
                );

            } catch (err) {

                console.log(err);

            }

        };

    const deleteSalesReturn =
        async (id) => {

            if (
                !window.confirm(
                    "Delete Sales Return?"
                )
            ) return;

            try {

                const token =
                    localStorage.getItem(
                        "adminToken"
                    );

                await API.delete(
                    `/sales-returns/${id}`,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`
                        }
                    }
                );

                loadSalesReturns();

            } catch (err) {

                console.log(err);

            }

        };

    return (

        <div>

            {/* Header */}

            <div
                className="
        flex
        flex-col
        md:flex-row
        md:justify-between
        md:items-center
        gap-4
        mb-6
        "
            >

                <div>

                    <h1
                        className="
            text-4xl
            font-bold
            "
                    >
                        Sales Returns
                    </h1>

                    <p
                        className="
            text-gray-400
            mt-2
            "
                    >
                        Manage Returned Sales
                    </p>

                </div>

                {hasPermission("sales_return.add") && (
                    <Link
                        to="/admin/sales-returns/add"
                        className="
          bg-yellow-500
          text-black
          px-6
          py-3
          rounded-xl
          font-semibold
          "
                    >
                        Add Sales Return
                    </Link>
                )}

            </div>

            {/* Search */}

            <div
                className="
        mb-6
        "
            >

                <input
                    type="text"
                    value={search}
                    onChange={(e) =>
                        setSearch(
                            e.target.value
                        )
                    }
                    placeholder="Search Return No..."
                    className="
          w-full
          md:w-96
          p-3
          rounded-xl
          bg-[#111]
          border
          border-yellow-500/20
          "
                />

            </div>

            {/* Mobile UI Starts Here */}

            <div
                className="
        md:hidden
        space-y-4
        "
            >
                {salesReturns.length > 0 ? (

                    salesReturns.map(
                        (item) => (

                            <div
                                key={item.id}
                                className="
                bg-[#111]
                rounded-2xl
                p-5
                border
                border-yellow-500/20
                "
                            >

                                <div
                                    className="
                    flex
                    justify-between
                    items-center
                    "
                                >

                                    <div>

                                        <h3
                                            className="
                            font-bold
                            text-lg
                            "
                                        >
                                            {item.return_no}
                                        </h3>

                                        <p
                                            className="
                            text-gray-400
                            text-sm
                            "
                                        >
                                            {new Date(item.created_at).toLocaleString()}
                                        </p>

                                    </div>

                                    <span
                                        className="
                        bg-red-500/20
                        text-red-400
                        px-3
                        py-1
                        rounded-full
                        text-sm
                        "
                                    >
                                        Return
                                    </span>

                                </div>

                                <div
                                    className="
                    mt-5
                    space-y-2
                    "
                                >

                                    <div
                                        className="
                        flex
                        justify-between
                        "
                                    >

                                        <span className="text-gray-400">
                                            Customer
                                        </span>

                                        <span>
                                            {item.customer_name}
                                        </span>

                                    </div>

                                    <div
                                        className="
                        flex
                        justify-between
                        "
                                    >

                                        <span className="text-gray-400">
                                            Wallet
                                        </span>

                                        <span>
                                            {item.wallet_name}
                                        </span>

                                    </div>

                                    <div
                                        className="
                        flex
                        justify-between
                        "
                                    >

                                        <span className="text-gray-400">
                                            Amount
                                        </span>

                                        <span
                                            className="
                            text-red-400
                            font-bold
                            "
                                        >
                                            ₹
                                            {Number(
                                                item.grand_total
                                            ).toFixed(2)}
                                        </span>

                                    </div>

                                </div>

                                <div
                                    className="
                    grid
                    grid-cols-3
                    gap-2
                    mt-6
                    "
                                >
                                    {hasPermission("sales_return.view") && (
                                        <>
                                            <button
                                                onClick={() =>
                                                    navigate(
                                                        `/admin/sales-returns/view/${item.id}`
                                                    )
                                                }
                                                className="
                        bg-blue-500
                        py-2
                        rounded-xl
                        "
                                            >
                                                View
                                            </button>
                                        </>
                                    )}

                                    {hasPermission("sales_return.delete") && (
                                        <button
                                            onClick={() =>
                                                deleteSalesReturn(
                                                    item.id
                                                )
                                            }
                                            className="
                        bg-red-500
                        py-2
                        rounded-xl
                        "
                                        >
                                            Delete
                                        </button>
                                    )}

                                </div>

                            </div>

                        )
                    )

                ) : (

                    <div
                        className="
        bg-[#111]
        rounded-2xl
        p-8
        text-center
        text-gray-400
        "
                    >
                        No Sales Returns Found
                    </div>

                )}

            </div>

            {/* Desktop Table Starts Here */}

            <div
                className="
    hidden
    md:block
    bg-[#111]
    rounded-2xl
    overflow-hidden
    "
            >
                <div
                    className="
    overflow-x-auto
    "
                >

                    <table
                        className="
        w-full
        "
                    >

                        <thead>

                            <tr
                                className="
                border-b
                border-yellow-500/20
                "
                            >

                                <th className="p-4 text-left">
                                    Return No
                                </th>

                                <th className="p-4 text-left">
                                    Customer
                                </th>

                                <th className="p-4 text-left">
                                    Wallet
                                </th>

                                <th className="p-4 text-left">
                                    Date
                                </th>

                                <th className="p-4 text-left">
                                    Amount
                                </th>

                                <th className="p-4 text-left">
                                    Action
                                </th>

                            </tr>

                        </thead>

                        <tbody>

                            {salesReturns.length > 0 ? (

                                salesReturns.map(
                                    (item) => (

                                        <tr
                                            key={item.id}
                                            className="
                            border-b
                            border-yellow-500/10
                            hover:bg-yellow-500/5
                            "
                                        >

                                            <td className="p-4 font-semibold">
                                                {item.return_no}
                                            </td>

                                            <td className="p-4">
                                                {item.customer_name}
                                            </td>

                                            <td className="p-4">
                                                {item.wallet_name}
                                            </td>

                                            <td className="p-4">
                                                {new Date(item.created_at).toLocaleString()}
                                            </td>

                                            <td
                                                className="
                                p-4
                                text-red-400
                                font-bold
                                "
                                            >
                                                ₹
                                                {Number(
                                                    item.grand_total
                                                ).toFixed(2)}
                                            </td>

                                            <td className="p-4">

                                                <div
                                                    className="
                                    flex
                                    gap-2
                                    flex-wrap
                                    "
                                                >
                                                    {hasPermission("sales_return.view") && (
                                                        <button
                                                            onClick={() =>
                                                                navigate(
                                                                    `/admin/sales-returns/view/${item.id}`
                                                                )
                                                            }
                                                            className="
                                        bg-blue-500
                                        px-4
                                        py-2
                                        rounded-xl
                                        "
                                                        >
                                                            View
                                                        </button>

                                                    )}

                                                    {hasPermission("sales_return.delete") && (
                                                        <button
                                                            onClick={() =>
                                                                deleteSalesReturn(
                                                                    item.id
                                                                )
                                                            }
                                                            className="
                                        bg-red-500
                                        px-4
                                        py-2
                                        rounded-xl
                                        "
                                                        >
                                                            Delete
                                                        </button>
                                                    )}

                                                </div>

                                            </td>

                                        </tr>

                                    )
                                )

                            ) : (

                                <tr>

                                    <td
                                        colSpan="6"
                                        className="
                        p-8
                        text-center
                        text-gray-400
                        "
                                    >
                                        No Sales Returns Found
                                    </td>

                                </tr>

                            )}

                        </tbody>

                    </table>

                </div>

            </div>

            {/* Pagination */}

            {
                pages > 1 && (

                    <div
                        className="
    flex
    justify-center
    gap-2
    mt-8
    flex-wrap
    "
                    >

                        {
                            Array.from(
                                {
                                    length: pages
                                },
                                (_, index) => (

                                    <button
                                        key={index}
                                        onClick={() =>
                                            setPage(
                                                index + 1
                                            )
                                        }
                                        className={`
                px-4
                py-2
                rounded-xl
                ${page ===
                                                index + 1
                                                ? "bg-yellow-500 text-black"
                                                : "bg-[#111]"
                                            }
                `}
                                    >
                                        {index + 1}
                                    </button>

                                )
                            )
                        }

                    </div>

                )
            }

        </div>
    );
}

export default SalesReturns;